import { useQuery } from '@tanstack/react-query';
import { clientService } from '@services/client';
import { useTranslation } from '@hooks/useTranslation';
import { toast } from 'react-toastify';
import { Client } from '@models/client.model';

export const CLIENT_QUERY_KEY = (clientId: string | undefined) => [
  'client',
  clientId ?? 'unknown',
];

export const useClient = (clientId: string | undefined) => {
  const localeCommon = useTranslation('common');

  return useQuery<Client, Error>({
    queryKey: CLIENT_QUERY_KEY(clientId),
    enabled: !!clientId,
    retry: false, // Don't retry on error for client not found
    queryFn: async () => {
      try {
        if (!clientId) throw new Error('clientId is required');
        return await clientService.getClientById(clientId);
      } catch (error: any) {
        const errorMessage =
          error?.response?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          error?.message ||
          localeCommon['requestError'];

        toast.error(errorMessage);
        throw error;
      }
    },
  });
};

export default useClient;
